<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title pt-2">
        <div class="row px-1">
          <!--Messaggio con rapportino + utente + stato-->
          <div class="col-12 d-flex align-items-center px-2">
            <h3 class="m-0" ngClass.md="mt-1">{{ "WORKDAY_REPORT_OF" | translate }} {{ currentMonthAndYear }}</h3>
            <span ngClass.sm="mt-1" class="font-small-3 badge badge-secondary ml-1" *ngIf="statusReport === -1">{{ "STATUS.NOT_SAVED" | translate }}</span>
            <div ngClass.xl="ml-1">
              <ng-container [ngSwitch]="statusReport">
                <span ngClass.sm="mt-1" class="font-small-3 badge badge-success" *ngSwitchCase="2">{{ "APPROVED" | translate }}</span>
                <span ngClass.sm="mt-1" class="font-small-3 badge badge-danger" *ngSwitchCase="3">{{ "REJECTED" | translate }}</span>
                <span ngClass.sm="mt-1" class="font-small-3 badge badge-warning" *ngSwitchCase="1">{{ "PENDING" | translate }}</span>
              </ng-container>
            </div>
          </div>
          <div class="col-12 px-2 mt-05 mb-1">
            <!--Messaggio per il l'invio del rapportino-->
            <div *ngIf="!lockReport && (statusReport === -1 || statusReport === 0)" class="font-small-4">{{ "NOW_YOU_CAN_SEND_REPORT" | translate }}</div>
            <!--Messaggio per il l'invio del rapportino-->
            <div *ngIf="lockReport && (statusReport === -1 || statusReport === 0) && unlockDay" class="font-small-4">
              {{ "UNLOCK_WORKDAY_REPORT_LABEL" | translate }} <span class="text-danger">{{ _utilService.formatDate(unlockDay, "DD MMMM.") }}</span>
            </div>
            <!--Nota rifiuto-->
            <div *ngIf="statusReport === 3">
              <p class="font-small-3 mb-0 pb-0">{{ "MOTIVATION" | translate }}:</p>
              <p class="font-small-4">{{ statusNoteReport }}</p>
            </div>
          </div>
          <div class="col-12 px-2">
            <a class="font-small-3 text-primary" (click)="showVideo()">
              {{ "DONT_KNOW_HOW_TO_DO" | translate }}
            </a>
          </div>
        </div>
      </div>
      <div class="card-body" *ngIf="myReport">
        <!--header tabella-->
        <div class="row" id="table-header" *ngIf="!_utilService.isMobile && !_utilService.isTablet" #tableHeader>
          <div class="col-xl-2 col-12">
            <h4>{{ "DAYS" | translate | titlecase }}</h4>
          </div>
          <div class="col-xl-2 col-12">
            <h4>{{ "WORKED_HOURS" | translate }}</h4>
          </div>
          <div class="col-xl-3 col-12">
            <h4>{{ "EXTRA_HOURS" | translate }}</h4>
          </div>
          <div class="col-xl-3 col-12">
            <h4>{{ "TITLES.COMMISSIONS" | translate }}</h4>
          </div>
          <div class="col-xl-2 col-12">
            <h4>{{ "NOT_WORKED_HOURS" | translate }}</h4>
          </div>
        </div>
        <!--elenco giorni-->
        <div class="row align-items-center day-row py-2" *ngFor="let day of daysOfTheMonth" [ngClass]="getDayRowClasses(day)" [ngbTooltip]="getDayRowTooltip(day) | translate" placement="top-left" id="day-{{ day }}">
          <div class="col-12">
            <div class="row align-items-center">
              <!--Giorno-->
              <div class="col-xl-2 col-12 cursor-pointer" (click)="statusReport === 0 ? openRow(day) : null">
                <div class="d-flex align-items-center">
                  <div class="px-0 mr-05" *ngIf="statusReport === 0 && openedRow !== day && myReport[day].commissions.length > 0 && !hasFullDayAbsence(day)">
                    <i [data-feather]="'chevron-down'" class="text-secondary" size="20"></i>
                  </div>
                  <div class="px-0 mr-05" *ngIf="openedRow === day && myReport[day].commissions.length > 0 && !hasFullDayAbsence(day)">
                    <i [data-feather]="'chevron-up'" class="text-secondary" size="20"></i>
                  </div>
                  <span>{{ _utilService.formatDate(day, "dddd DD") | titlecase }}</span>
                </div>
              </div>
              <!-- Ore lavorative -->
              <div class="col-xl-2 col-12">
                <div *ngIf="openedRow !== day">
                  <span *ngIf="myReport[day].working_hours == 0" class="badge badge-light-warning"> {{ myReport[day].working_hours }} {{ "HOURS_TO_ALLOCATE" | translate | lowercase }} </span>
                  <span *ngIf="myReport[day].working_hours > 0" class="badge badge-{{ myReport[day].residual_hours < 1 ? 'light-' : '' }}warning">
                    {{ myReport[day].residual_hours }} {{ "HOURS_TO_ALLOCATE" | translate | lowercase }}
                  </span>
                </div>
                <span class="badge badge-warning" *ngIf="openedRow === day">{{ myReport[day].residual_hours }} {{ "HOURS_TO_ALLOCATE" | translate | lowercase }}</span>
              </div>
              <!-- Ore extra -->
              <div class="col-xl-3 col-12 extra-hours">
                <div *ngIf="openedRow !== day">
                  {{ _utilService.isMobile || _utilService.isTablet ? ("EXTRA" | translate) + ":" : null }}
                  <span *ngFor="let comm of myReport[day].commissions; let i = index">
                    <span class="mr-05 mb-05" *ngIf="comm.extra.hours > 0">
                      <span class="badge badge-light-secondary" [ngbTooltip]="comm.extra.hours + ('_EXTRA_HOURS_ALLOCATED_TO_' | translate) + comm.client_name + ('_AS_' | translate) + (comm.extra.type_name | lowercase)">
                        {{ comm.extra.hours + "h" }} {{ comm.extra.type_name }} ({{ comm.client_name }})
                      </span>
                    </span> </span
                  ><span *ngFor="let structure of myReport[day].structures; let i = index">
                    <span class="mr-05 mb-05" *ngIf="structure.extra.hours > 0">
                      <span class="badge badge-light-secondary"
                        [ngbTooltip]="structure.extra.hours + ('_EXTRA_HOURS_ALLOCATED_TO_' | translate) + structure.company_name + ('_AS_' | translate) + (structure.extra.type_name | lowercase)"
                      >
                        {{ structure.extra.hours + "h" }} {{ structure.extra.type_name }} ({{ structure.client_name }})
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <!--Ore allocate sulle commesse e sulla struttura-->
              <div class="col-xl-3 col-12">
                <div *ngIf="myReport[day].allocated_hours >= myReport[day].working_hours && myReport[day].allocated_hours > 0 && openedRow !== day; else addCommissionHoursBtn">
                  <span
                    *ngFor="let comm of myReport[day].commissions"
                    class="badge badge-light-success mr-05 mb-05"
                    [ngClass]="comm.worked < 1 ? 'd-none' : ''"
                    [ngbTooltip]="comm.worked + ('_HOURS_ALLOCATED_TO_' | translate) + comm.client_name"
                  >
                    {{ comm.worked }}h {{ comm.client_name }}
                  </span>
                  <span
                    *ngFor="let comm of myReport[day].structures"
                    class="badge badge-light-success mr-05 mb-05"
                    [ngClass]="comm.worked < 1 ? 'd-none' : ''"
                    [ngbTooltip]="comm.worked + ('_HOURS_ALLOCATED_TO_' | translate) + comm.company_name"
                  >
                    {{ comm.worked }}h {{ comm.company_name }}
                  </span>
                </div>
                <ng-template #addCommissionHoursBtn>
                  <button
                    (click)="openRow(day)"
                    *ngIf="myReport[day].residual_hours > 0 && openedRow !== day"
                    class="btn btn-outline-success rounded-circle p-05 mx-auto"
                    placement="right"
                    [ngbTooltip]="'ASSIGN_HOURS' | translate"
                  >
                    <i data-[data-feather]="'plus'" size="15"></i>
                  </button>
                  <button (click)="openRow(day)" *ngIf="openedRow === day" class="btn btn-outline-secondary rounded-circle p-05 mx-auto" placement="right" [ngbTooltip]="'ASSIGN_HOURS' | translate">
                    <i data-[data-feather]="'minus'" size="15"></i>
                  </button>
                </ng-template>
              </div>
              <!--assenze-->
              <div class="col-xl-2 col-12">
                <span class="d-flex" *ngFor="let permission_hour of myReport[day].absences">
                  <span [ngbTooltip]="permission_hour?.name.length > 15 ? permission_hour.name : null" class="badge badge-light-primary mr-05 text-break-line-1 {{ myReport[day].absences.length > 1 ? 'mb-05' : '' }}">
                    {{ permission_hour.category === "permesso" ? permission_hour.hours + "h" : "" }} {{ permission_hour.name }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <!--dettaglio giorno-->
          <div class="col-12 day-details" [ngClass]="openedRow === day ? 'opened' : ''">
            <div class="row align-items-center">
              <div class="col-md-2 font-weight-bold">{{ "MENU.COMMISSION" | translate }}</div>
              <div class="col-md-2 font-weight-bold">{{ "WORKED_HOURS" | translate }}</div>
              <div class="col-md-8 font-weight-bold" *ngIf="!hasFullDayAbsence(day)">{{ "EXTRA_HOURS" | translate }}</div>
            </div>
            <!--elenco commesse-->
            <div class="row day-detail align-items-center" *ngFor="let comm of myReport[day].commissions; let i = index">
              <!--nome commessa con tooltip descrizione-->
              <div class="col-2" [ngbTooltip]="comm.client_name" placement="top-left">{{ comm.client_name }}</div>
              <!--input ore lavorate-->
              <div class="col-2 worked-hours">
                <input
                  type="number"
                  class="form-control"
                  (change)="setWorkedHours($event.target)"
                  date="{{ day }}"
                  commission_index="{{ i }}"
                  [(ngModel)]="comm.worked"
                  [disabled]="myReport[day].working_hours < 1 || (myReport[day].commissions.length + myReport[day].structures.length) === 1"
                  [max]="myReport[day].working_hours"
                  min="0"
                />
              </div>
              <div class="col-8 worked-hours" *ngIf="!hasFullDayAbsence(day)">
                <div class="d-flex flex-xl-nowrap flex-wrap align-items-center">
                  <!--input ore extra -->
                  <input
                    class="form-control w-25 mr-075"
                    type="number"
                    min="0"
                    [ngbTooltip]="'EXTRA_HOURS' | translate"
                    [id]="'extra-hours-' + comm.order_id"
                    [(ngModel)]="comm.extra.hours"
                    [max]="12"
                    (change)="setExtraHours($event.target, 'commissions', day, i)"
                  />
                  <!--select categorie extra -->
                  <ng-select
                    class="mr-1 w-50"
                    bindValue="id"
                    bindLabel="name"
                    [placeholder]="'CATEGORY' | translate"
                    id="categoryAbsence2"
                    (change)="setExtra($event, day, i)"
                    [(ngModel)]="comm.extra.type"
                    [closeOnSelect]="true"
                    [clearable]="false"
                    [openOnEnter]="false"
                    [virtualScroll]="true"
                    [items]="categoriesAbsencesList"
                  >
                  </ng-select>
                  <!--bottone annulla -->
                  <button class="btn btn-sm mr-1 mt-1 mt-xl-0" *ngIf="comm.extra.hours > 0 || comm.extra.type" (click)="cancelExtraHour(day, i)" [ngbTooltip]="'CANCEL' | translate">
                    <i data-feather="x" class="text-warning" size="16"></i>
                  </button>
                </div>
              </div>
            </div>
            <!--elenco costi struttura-->
            <div class="row day-detail align-items-center" *ngFor="let structure of myReport[day].structures; let i = index">
              <!--nome commessa con tooltip descrizione-->
              <div class="col-2" [ngbTooltip]="structure.company_name" placement="top-left">{{ structure.company_name }}</div>
              <!--input ore lavorate-->
              <div class="col-2 worked-hours">
                <input
                  type="number"
                  class="form-control"
                  (change)="setWorkedHours($event.target)"
                  date="{{ day }}"
                  commission_index="{{ i }}"
                  [(ngModel)]="structure.worked"
                  [disabled]="myReport[day].working_hours < 1 || myReport[day].structures.length === 1"
                  [max]="myReport[day].working_hours"
                  min="0"
                />
              </div>
              <div class="col-8 worked-hours" *ngIf="!hasFullDayAbsence(day)">
                <div class="d-flex flex-xl-nowrap flex-wrap align-items-center">
                  <!--input ore extra -->
                  <input
                    class="form-control w-25 mr-075"
                    type="number"
                    min="0"
                    [ngbTooltip]="'EXTRA_HOURS' | translate"
                    [id]="'extra-hours-' + structure.cost_id"
                    [(ngModel)]="structure.extra.hours"
                    [max]="12"
                    (change)="setExtraHours($event.target, 'structures', day, i)"
                  />
                  <!--select categorie extra -->
                  <ng-select
                    class="mr-1 w-50"
                    bindValue="id"
                    bindLabel="name"
                    [placeholder]="'CATEGORY' | translate"
                    id="categoryAbsence2"
                    (change)="setExtra($event, day, i, 'structures')"
                    [(ngModel)]="structure.extra.type"
                    [closeOnSelect]="true"
                    [clearable]="false"
                    [openOnEnter]="false"
                    [virtualScroll]="true"
                    [items]="categoriesAbsencesList"
                  >
                  </ng-select>
                  <!--bottone annulla -->
                  <button class="btn btn-sm mr-1 mt-1 mt-xl-0" *ngIf="structure.extra.hours > 0 || structure.extra.type" (click)="cancelExtraHour(day, i, 'structures')" [ngbTooltip]="'CANCEL' | translate">
                    <i data-feather="x" class="text-warning" size="16"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer border-0">
        <div class="row">
          <div class="col-md-6 col-12">
            <!--Conteggio ore totali -->
            <div class="row justify-content-start align-items-start mb-1">
              <div class="col-xl-2 col-12">
                <label for="totalWorkedHours">{{ "WORKED_HOURS" | translate }}:</label>
                <div id="totalWorkedHours">{{ totalWorkedHours }}h</div>
              </div>
              <div class="col-xl-3 col-12" [ngClass.sm]="'my-05'">
                <label for="totalNotWorkedHours">{{ "NOT_WORKED_HOURS" | translate }}:</label>
                <div id="totalNotWorkedHours">{{ totalNotWorkedHours }}h</div>
              </div>
              <div class="col-xl-3 col-12">
                <label for="totalExtraHours">{{ "EXTRA_HOURS" | translate }}:</label>
                <div id="totalExtraHours" class="mr-3">{{ totalExtraHours }}h</div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12" *ngIf="canSendReport">
            <div class="row">
              <!--Tasti visualizzabili soltanto dall'utente-->
              <div class="col-12">
                <!--Messaggio invio report dal -->
                <div *ngIf="(statusReport === -1 || statusReport === 0) && lockReport && unlockDay && !isArchivedReport" class="font-weight-bolder d-flex justify-content-end mb-075">
                  {{ "REPORT_AVAILABLE_FROM" | translate }}&nbsp;<span class="text-danger">{{unlockDay | date:'dd MMMM' }}</span>
                </div>
                <!-- Bottoni salva aggiorna e invia report -->
                <div class="d-flex justify-content-end" *ngIf="isArchivedReport || (statusReport < 1 || statusReport == 3)">
                  <button class="btn btn-primary" (click)="idReport ? update() : save()" [disabled]="!isArchivedReport && (lockReport || rowsWithErrorMissingHours.length > 0)">{{ "SEND" | translate }}</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12 text-right" *ngIf="!canSendReport">
            <p class="mb-0">{{'YOU_CANNOT_SEND_REPORT_BECAUSE_WITHOUT_COMMISSION' | translate}}</p>
            <p>{{'PLEASE_CONTACT_ADMINISTRATION' | translate}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
